import { render, staticRenderFns } from "./potentialCandidateList.vue?vue&type=template&id=0ac6ce7b&scoped=true"
import script from "./potentialCandidateList.vue?vue&type=script&lang=js"
export * from "./potentialCandidateList.vue?vue&type=script&lang=js"
import style0 from "./potentialCandidateList.vue?vue&type=style&index=0&id=0ac6ce7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac6ce7b",
  null
  
)

export default component.exports